import { dateTypes,  } from "../dates/date-models"
import { getDateAsMoment, getDateFormattedAsMoment, getMomentPlusTime } from "../../../core/utils/dates";
import qs from 'qs';
export const itemsPerPageOptionsTable: Array<number> = [10, 15, 30, 50, 100, -1];

export const getStringValue = (value) => {
    switch (typeof value) {
      case 'string': case 'object': return JSON.stringify(value);
      default: return String(value);
    }
  }
export const stringComparision = (valueA, valueB, asc) => {
    valueA = getStringValue(valueA);
    valueB = getStringValue(valueB);
    if (!asc) {
        return valueA.localeCompare(valueB);
    } else {
        return valueB.localeCompare(valueA);
    }
}

export const numericComparision = (valueA, valueB, asc) => {
    if (asc) {
        return valueA == valueB ? 0 : valueA < valueB ? 1 : -1;
    } else {
        return valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
    }
}

export const dateComparision = (dateFromA, dateFromB, asc) => {
    dateFromA = dateFromA !== null ? getDateFromDateFormatApi(dateFromA) : 0;
    dateFromB = dateFromB !== null ? getDateFromDateFormatApi(dateFromB) : 0;
    return numericComparision(dateFromA, dateFromB, asc);
}

export const getDateFromDateFormatApi = (date: string): Date => getDateAsMoment(date).toDate();



export const tableSort = (items: object[], sortBy: string[], sortDesc: boolean[]) => {
    items.sort(function(a, b): number {
        let sorts: number[] = [];
        for (let i = 0; i < sortBy.length; i++) {
            let condition = 0;
            switch (sortBy[i]) {
                case 'datetime_from':
                case 'datetime_to':
                            let dateToA = getDateFromDateFormatApi(a[sortBy[i]]);
                            let dateToB = getDateFromDateFormatApi(b[sortBy[i]]);
                            if (!sortDesc[i]) {
                                if (a[sortBy[i]] == null && b[sortBy[i]] == null) {
                                    condition = 0;
                                } else if (a[sortBy[i]] == null) {
                                    condition = -1;
                                } else if (b[sortBy[i]] == null) {
                                    condition = 1;
                                } else {
                                    condition = dateToA == dateToB ? 0 : dateToA < dateToB ? 1 : -1;
                                }
                            } else {
                                if (a[sortBy[i]] == null && b[sortBy[i]] == null) {
                                    condition = 0;
                                } else if (a[sortBy[i]] == null) {
                                    condition = 1;
                                } else if (b[sortBy[i]] == null) {
                                    condition = -1;
                                } else {
                                    condition = dateToA == dateToB ? 0 : dateToA > dateToB ? 1 : -1;
                                }
                            }
                            break;
              
                default:
                    let kei = sortBy[i];
                    if (kei.indexOf('.') > -1) {
                        let keis = kei.split('.');
                        let kei1 = keis[0];
                        let kei2 = keis[1];

                        let sortKey1 = a[kei1][kei2];
                        let sortKey2 = b[kei1][kei2];

                        
                        if(sortKey1 && typeof sortKey1 === 'object'){
                            if(sortKey1.hasOwnProperty('description')){
                                sortKey1 = sortKey1['description'];
                            }
                        }

                        if(sortKey2 && typeof sortKey2 === 'object'){
                            if(sortKey2.hasOwnProperty('description')){
                                sortKey2 = sortKey2['description'];
                            }
                        }

                       condition = stringComparision(sortKey1, sortKey2, sortDesc[i]);
                    } else {
                        // Handle non-nested keys
                        condition = stringComparision(a[kei], b[kei], sortDesc[i]);
                    }
                    break;
                
            }
            sorts.push(condition);
        }
        let result = 0;
        for (let i = 0; i < sorts.length; i++) {
            if (sorts[i] != 0) {
                return sorts[i];
            }
        }
        return result;
    });
    return items;
}

export const nestedFilter = (value: any, search: string | null, item: any): boolean => {
    return value != null &&
        search != null &&
        typeof value !== 'boolean' &&
        getObjectWithLowerCaseStrings(value).includes(search.toLowerCase())
}
export const getMatches = (pred) => (obj) =>
  Object (obj) === obj
    ? Object .values (obj) .flatMap (getMatches (pred))
  : pred (obj)
    ? obj
  : []


export const parseParametersToSendBackend = (params:object):string => {
    let parsedParams = JSON.parse(JSON.stringify(params));

    Object.keys(parsedParams).forEach((key) => {
        if(Array.isArray(parsedParams[key])){
            parsedParams[key] = parsedParams[key].join(',')
        }
    })

    if(parsedParams.hasOwnProperty('sort_by')){
        //formateo las columnas que apuntan a una clave dentro de un diccionario
        //backend las prefiere con guion bajo en lugar de punto
        
        if(parsedParams['sort_by'].includes('.')){
            parsedParams['sort_by'] = parsedParams['sort_by'].replace(/\./g, '_');
        }        
    }
    
    return qs.stringify(parsedParams, { encode: false });
}


 export const getObjectWithLowerCaseStrings = (object: object): string => {
   return JSON.stringify(object, function(a, b) {
        return typeof b === "string" ? b.toLowerCase() : b
    });
 } 


  export function defaultTableFilter (value: any, search: string | null, item: any) {
    if (Array.isArray(value) && search !== null) {
        return value.some(it=>Object.values(it).some(function(v:any){
            return v&&v.toString().toLowerCase().includes(search.toLocaleLowerCase())
        }))
    }
    return value != null &&
    search != null &&
    typeof value !== 'boolean' &&
    value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
}

export function watchClass(targetNode, classToWatch) {
    let lastClassState = targetNode.classList.contains(classToWatch);
    const observer = new MutationObserver((mutationsList) => {
            for (let i = 0; i < mutationsList.length; i++) {
            const mutation:any = mutationsList[i];
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const currentClassState = mutation.target.classList.contains(classToWatch);
                    if (lastClassState !== currentClassState) {
                    lastClassState = currentClassState;
                    if (!currentClassState) {
                        mutation.target.classList.add('sortHandle');
                    }
                    }
                }
            }
        });
        observer.observe(targetNode, { attributes: true });
    }

export const getParsedAlerts = (alerts: string[]) => {
    let msgs: string[] = [];
    for (let index = 0; index < alerts.length; index++) {
        let alert = alerts[index];
        if (alert.indexOf('<br>') == -1) {
            alert += '<br>';
        }
        msgs.push(alert);
    }

    return {
        msgs: msgs
    };
}
